import { UI } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { EquityEntity } from '@genial/services';
import { Utils, useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Button } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

export interface BookOffersButtonProps {
  equity: EquityEntity;
}

export const BookOffersButton: React.FC<BookOffersButtonProps> = ({ equity }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const onViewOffers = () => {
    const data = { ...equity, canUpdate: true };
    navigate('EquityOffersBookModal', data);
  };

  const desktopButton = (
    <Button
      w="110px"
      testID="table-equity-offers"
      variant="primary"
      backgroundColor={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.45)}
      _text={{ color: Color['brand.tertiary.principal'] }}
      shadow="none"
      borderRadius={BoxRadius.sm}
      onPress={onViewOffers}
      rightIcon={<UI.Icon name="Book" color={Color['brand.tertiary.principal']} size="xxs" />}>
      OFERTAS
    </Button>
  );

  const responsiveButton = (
    <Button
      testID="table-equity-offers"
      variant="unstyled"
      backgroundColor={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.45)}
      _text={{ color: Color['brand.tertiary.principal'] }}
      shadow="none"
      h={Spacing['inline.md']}
      w={Spacing['inline.md']}
      onPress={onViewOffers}
      borderRadius={BoxRadius.sm}
      rightIcon={<UI.Icon name="Book" color={Color['brand.tertiary.principal']} size="xs" />}
    />
  );

  const button = useBreakpointValue({
    base: responsiveButton,
    sm: responsiveButton,
    lg: desktopButton,
  });

  return button;
};
